import { Controller } from 'stimulus';

export default class extends Controller {
  dismiss() {
    this.element.classList.add('is-dismissed');
    this.element.addEventListener('transitionend', () => {
      this.element.parentNode.removeChild(this.element);
    });
  }
}
